import React, { useEffect, useState, useRef } from 'react';

const stats = [
  { value: '+500', label: 'Eventos realizados' },
  { value: '30+ anos', label: 'De experiência' },
  { value: '98%', label: 'Satisfação dos clientes' },
];

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="bg-[#111111] py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`text-center transition-all duration-700 ${
                isVisible
                  ? 'opacity-100 translate-y-0'
                  : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#8B6F47] to-[#D4B483] font-display text-5xl md:text-6xl font-bold">
                {stat.value}
              </span>
              <p className="font-body text-sm tracking-[0.2em] uppercase text-white/50 mt-3">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
